import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Tab,
  Tabs,
  Typography,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Dashboard } from "@mui/icons-material";

const Sidebar = ({
  selectedStatus,
  handleTabChange,
  statusCounts,
  unReadCount,
  notificationCount,
  noOfCustomers,
  noOfPendingCustomers,
  groupedTabs
}) => {
  const isArray = (variable) => Array.isArray(variable);

  

  const renderTabs = (tabs) => (
    <Tabs
      orientation="vertical"
      value={selectedStatus}
      onChange={handleTabChange}
      variant="scrollable"
    >
      {isArray(tabs) &&
        tabs.map((status) => (
          <Tab
            key={status}
            value={status}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: "11px", flexGrow: 1, color: selectedStatus === status ? "white" : "black", }}>
                  {status}
                </Typography>

                {/* Badge counts */}
                {status !== "Customer Search" && status !== "Ticket Search" && status !== "Reports" && (
                  (() => {
                    if (
                      (status === "Messages" && unReadCount === 0) ||
                      (status === "Notification" && notificationCount === 0)||
                      (status === "Create Users")
                    ) {
                      return null;
                    }
                    return (
                      <Typography
                        sx={{
                          fontSize: "11px",
                          backgroundColor:
                            selectedStatus === status ? "#0e1422" : "#f1f1f1",
                          borderRadius: "12px",
                          padding: "2px 6px",
                          ml: 1,
                            color: selectedStatus === status ? "white" : "black",
                        }}
                      >
                        {(() => {
                          if (status === "Messages") return unReadCount;
                          if (status === "Notification") return notificationCount;
                          if (status === "Customers") return noOfCustomers;
                          if (status === "Pending Clients")
                            return noOfPendingCustomers;
                         
                          return statusCounts[status] || 0;
                        })()}
                      </Typography>
                    );
                  })()
                )}
              </Box>
            }
            sx={{
              minHeight: "30px",
              height: "30px",
              fontWeight: selectedStatus === status ? "bold" : "normal",
              backgroundColor:
                selectedStatus === status ? "#ff4700" : "transparent",
              color: selectedStatus === status ? "white" : "black",
              borderRadius: selectedStatus === status ? "4px" : "0",
              mb: 0,
            }}
          />
        ))}
    </Tabs>
  );

  return (
    <Box
      sx={{
        width: "240px",
        borderRight: "1px solid #e0e0e0",
        p: 1,
        bgcolor: "#fafafa",
        height: "100vh",
        overflowY: "auto",
      }}
    >
        <Button
        fullWidth
        startIcon={<Dashboard />}
        onClick={() => handleTabChange(null, "Dashboard")}
        sx={{
          justifyContent: "flex-start",
          mb: 1,
          fontWeight: selectedStatus === "Dashboard" ? "bold" : "normal",
          bgcolor: selectedStatus === "Dashboard" ? "#ff4700" : "transparent",
          color: selectedStatus === "Dashboard" ? "white" : "black",
          borderRadius: "6px",
          textTransform: "none",
          "&:hover": {
            bgcolor:
              selectedStatus === "Dashboard" ? "#e63e00" : "rgba(0,0,0,0.04)",
          },
        }}
      >
        Dashboard
      </Button>
    
      {Object.entries(groupedTabs).map(([group, tabs]) => (
        <Accordion
          key={group}
        //   defaultExpanded={group === "Dashboard"}
          disableGutters
          sx={{
            boxShadow: "none",
            bgcolor: "transparent",
            "&:before": { display: "none" },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon fontSize="small" />}
            sx={{
              px: 1,
              py: 0.5,
              fontWeight: "bold",
              color: "#333",
              bgcolor: "#f4f4f4",
              borderRadius: "6px",
              mb: 0.5,
            }}
          >
            {group}
          </AccordionSummary>
          <AccordionDetails sx={{ py: 0, pl: 0 }}>
            {renderTabs(tabs)}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default Sidebar;
